import {Col, Container, Row} from "react-bootstrap";
import classes from "../styles/components/footer.module.scss";
import logo from "../images/logo.png";
import {BsArrowUpCircleFill} from "react-icons/bs";
import {AiFillInstagram} from "react-icons/ai";

function Footer(){
    return(
        <>
            <hr/>
            <Container className={classes.footer_layout}>
                <Row>
                    <Col xxl={4} xl={4} lg={4} md={3} sm={3} xs={3}>
                        <img src={logo} alt={"logo"} className={classes.logo}/>
                    </Col>
                    <Col xxl={4} xl={4} lg={4} md={6} sm={6} xs={6}>
                        <p className={classes.footer_description}>
                            Charlotte NC<br/>
                            Phone - <a href="sms:9808332222">9808332222</a><br/>
                            Email - <a href="mailto:mariaskinboutique.com@gmail.com?subject = mariaskinboutique.com">mariaskin</a><br/>
                            Developer - <a href="tel:9803831885">9803831885</a><br/>
                        </p>
                        <div className={classes.mediaLinks}>
                            <a href="https://www.instagram.com/kosmetologmaria_snk/" target="_blank"><AiFillInstagram className={classes.mediaIcons}/></a>
                        </div>
                    </Col>
                    <Col xxl={4} xl={4} lg={4} md={3} sm={3} xs={3}>
                        <a href="#top" className={classes.arrow}>
                            <BsArrowUpCircleFill/>
                        </a>
                    </Col>
                </Row>
            </Container>
        </>
    );
}

export default Footer;